import { render, staticRenderFns } from "./TestPackageGroupIndex.vue?vue&type=template&id=51d0fa9a"
import script from "./TestPackageGroupIndex.vue?vue&type=script&lang=js"
export * from "./TestPackageGroupIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports